function TreasureIcon(){
  return (
<svg width="200" height="200" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="48" fill="white" fillOpacity="0.01"/>
  <rect x="4" y="4" width="40" height="40" rx="2" stroke="#000000" strokeWidth="4" strokeLinejoin="round"/>
  <path d="M4 24H17" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M31 24H44" stroke="#000000" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31Z" fill="#2F88FF" stroke="#000000" strokeWidth="4" strokeLinejoin="round"/>
</svg>
  );
}

export default TreasureIcon;